var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editor1"}},[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig,"disabled":_vm.propDataEditorDisabled},on:{"input":_vm.onInputOption,"ready":_vm.onReadyOption,"blur":_vm.handleBlur},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }